import bannedEmailList from './bannedEmailList'

const regExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function validateEmail(str, forceWorkEmail) {
  if (
    forceWorkEmail
    && bannedEmailList.find(email => str.toLowerCase().trim().endsWith(email))
  ) {
    return false;
  }
  const result = regExp.exec(str.toLowerCase().trim());
  return result && result[0];
}

export function emailDomain(str) {
  const result = regExp.exec(str.toLowerCase().trim());
  return result ? result.slice(-2)[0] : '';
}

export function emailLocalPart(str) {
  const domain = emailDomain(str);
  return domain ? str.slice(0, -1 - domain.length) : str;
}

export function getEmailErrorMessage(str, forceWorkEmail) {
  if (str === '') return 'required';
  if (!validateEmail(str)) return 'email is invalid';
  if (
    forceWorkEmail
    && bannedEmailList.find(email => str.toLowerCase().trim().endsWith(email))
  ) {
    return 'please use your work email'
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/modules/signupForm/utils/email.js